export default {
  APOLOGIES_URL: '/our-apologies'
};



// WEBPACK FOOTER //
// ./app/constants/URL.js